module.exports = __webpack_public_path__ + "static/media/checkmark.3dfe1ba7.svg";